import React from "react";
import { RootState } from "../../../store/store";
import { confirmDialog } from "../../Dialog/actions";
import { connect } from 'react-redux';
import { IUserProfile } from "../../Auth/types";
import { ConstrainMode, IColumn, IconButton, IListProps, SelectionMode, ShimmeredDetailsList, TooltipHost } from "@fluentui/react";
import DetailsListWrapper from "../../../core/components/DetailsListWrapper/DetailsListWrapper";
import Configuration from "../../../core/libraries/Configuration";
import Constants from "../../../core/libraries/Constants";
import { getMappingDep, IMappingDepartment } from "../services";
import Helper from "../../../core/libraries/Helper";
import RbLabel, { LabelSize } from "../../../bosch-react/components/label/RbLabel";
import Template from "../../../core/libraries/Template";
import { PrincipalType } from "../../../core/components/PeoplePicker/types";
import DateTimeDisplay from "../../../core/components/DateTimeDisplay";
import RbButton, { ButtonSize, ButtonType } from "../../../bosch-react/components/button/RbButton";
import NoRecordsFound from "../../../core/components/NoRecordsFound";
import RbLoadingSpinner from "../../../bosch-react/components/loading-spinner/RbLoadingSpinner";
import { tooltipHostStyles } from "../Managements/types";

interface IProps {
    userProfile: IUserProfile | undefined,
    confirmDialog: typeof confirmDialog,
}

interface IState {
    items: IMappingDepartment[] | null,
    isLoading: boolean,
}

class DepsReadyForUpdate extends React.Component<IProps, IState> {

    constructor(props: any) {
        super(props);
        this.state = {
            items: null,
            isLoading: false,
        };
    }

    async componentDidMount() {
        await this.fetchData()
    }

    fetchData = async () => {
        const data = await getMappingDep(Constants.MAPPING_DEPARTMENT_STATUS.NeedUpdate)
        !!data && this.setState({
            items: data
        })
    }
    shimmeredDetailsListProps: IListProps = {
        renderedWindowsAhead: 0,
        renderedWindowsBehind: 0,
    };

    columns: IColumn[] = [
        {
            key: "oldName",
            name: "Old Name",
            currentWidth: Helper.resizeColumnByScreenWidth(10),
            minWidth: Helper.resizeColumnByScreenWidth(10),
            isResizable: true,
            onRender: (item: IMappingDepartment) => {
                return (
                    <RbLabel size={LabelSize.Small}>{item.department}</RbLabel>
                );
            },
        },
        {
            key: "newName",
            name: "New Name",
            currentWidth: Helper.resizeColumnByScreenWidth(20),
            minWidth: Helper.resizeColumnByScreenWidth(20),
            isResizable: true,
            onRender: (item: IMappingDepartment) => {
                return (
                    !!item.objectId && Template.renderReadOnlyGroup([item.objectId])
                );
            },
        },
        {
            key: "createdOn",
            name: "Created On",
            currentWidth: Helper.resizeColumnByScreenWidth(20),
            minWidth: Helper.resizeColumnByScreenWidth(20),
            isResizable: true,
            onRender: (item: IMappingDepartment) => {
                return (
                    !!item.created && <DateTimeDisplay date={item.created} />
                );
            },
        },
        {
            key: "modifiedOn",
            name: "Modified On",
            currentWidth: Helper.resizeColumnByScreenWidth(20),
            minWidth: Helper.resizeColumnByScreenWidth(20),
            isResizable: true,
            onRender: (item: IMappingDepartment) => {
                return (
                    !!item.modified && <DateTimeDisplay date={item.modified} />
                );
            },
        },
        {
            key: "modifiedBy",
            name: "Modified By",
            currentWidth: Helper.resizeColumnByScreenWidth(20),
            minWidth: Helper.resizeColumnByScreenWidth(20),
            isResizable: true,
            onRender: (item: IMappingDepartment) => {
                return (
                    !!item.modifiedBy && (item.modifiedBy.includes('-') ? Template.renderReadOnlyPeoplePickerTags(item.modifiedBy) : Template.renderReadOnlyPeople([item.modifiedBy]))
                );
            },
        },
        {
            key: "history",
            name: "History of Changes",
            currentWidth: Helper.resizeColumnByScreenWidth(20),
            minWidth: Helper.resizeColumnByScreenWidth(20),
            isResizable: true,
            onRender: (item: IMappingDepartment) => {
                return (
                    <RbLabel size={LabelSize.Small}>{item.history}</RbLabel>
                );
            },
        },
        {
            key: "action",
            name: "Action",
            currentWidth: Helper.resizeColumnByScreenWidth(20),
            minWidth: Helper.resizeColumnByScreenWidth(20),
            isResizable: true,
            onRender: (item: IMappingDepartment) => {
                return (
                    <RbButton type={ButtonType.Secondary} size={ButtonSize.Tiny} label='Update' onClick={() => {
                        Helper.openNewTab(`${process.env.REACT_APP_MOVE}/${item.department.replace('/', '_')}/${item.objectId}`)
                    }} />
                );
            },
        },
    ]

    render() {
        const { items } = this.state
        return (
            <div className="ms-Grid">
                <div className="ms-Grid-row common-padding-row">
                    <TooltipHost
                        content={"Helps users identify which departments within the selected division are valid or invalid. 'Invalid' indicates that the department either lacks a head, is obsolete, or has been removed from Bosch's organization."}
                        styles={tooltipHostStyles}
                        calloutProps={{ gapSpace: 10 }}
                    >
                        <IconButton
                            iconProps={{ iconName: "Info" }}
                            ariaLabel="Tab information"
                            title="Tab information"
                        />
                    </TooltipHost>
                </div>
                {this.state.isLoading && <div style={{ display: "block", width: "100%", height: "5rem", textAlign: "center" }}>
                    <RbLoadingSpinner />
                </div> || <DetailsListWrapper>
                        {!items || items.length===0 && <NoRecordsFound /> ||
                            <ShimmeredDetailsList
                                setKey="set"
                                compact={true}
                                items={items || []}
                                constrainMode={ConstrainMode.unconstrained}
                                columns={this.columns}
                                enableShimmer={!items}
                                selectionMode={SelectionMode.none}
                                ariaLabelForShimmer="Content is being fetched"
                                ariaLabelForGrid="Mapping Department List"
                                listProps={this.shimmeredDetailsListProps}
                                onRenderDetailsHeader={Configuration.onRenderStickyDetailsHeader}
                                onShouldVirtualize={() => { return true }}
                            />}
                    </DetailsListWrapper>}
            </div>
        )
    }
}


const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile
});

export default connect(mapStateToProps, { confirmDialog })(DepsReadyForUpdate);